// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./build/style/main.scss
// module id = 10
// module chunks = 0